import React from 'react';
import ProjectPage from '../../components/projects/ProjectPage';
import fifthElementData from '../../data/projects/fifthelement.js';

function FifthElement() {
  return <ProjectPage projectData={fifthElementData} />;
}

export default FifthElement;
